<div class="modal-header main-subscribe-offer-newsletter-title">
  <div class="modal-title pull-left">
    <b>Nyhetsbrev</b>
  </div>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body main-subscribe-offer-newsletter-body">
  <form #newsletterForm="ngForm" [formGroup]="form">
    <div *ngIf="!hasSent">
      Få de senaste nyheterna, inläggen och erbjudandena direkt i din inkorg. Inspiration, tips och exklusiva
      erbjudanden som gör din förvaltning enklare och mer värdefull.
    </div>
    <div>
      <!-- email -->
      <div class="control-wrapper" *ngIf="!hasSent">
        <label class="form-title">Din e-postadress *</label>
        <input
          matInput
          class="form-control"
          placeholder="name@example.com"
          autocomplete="off"
          formControlName="email"
          name="email"
          required
        />
        <mat-error *ngIf="form.controls['email']?.touched && form.controls['email']?.errors">
          Vänligen kontrollera e-postadressen
        </mat-error>
      </div>

      <!-- companyName -->
      <div class="control-wrapper" *ngIf="!hasSent">
        <label class="form-title">Namn på BRF/Företag (alt. privat) *</label>
        <input
          matInput
          class="form-control"
          placeholder="Namn på BRF/Företag (alt. privat)"
          autocomplete="off"
          formControlName="companyName"
          name="companyName"
        />
        <mat-error *ngIf="form.controls['companyName']?.touched && form.controls['companyName']?.errors">
          Minst 3 tecken krävs
        </mat-error>
      </div>

      <!-- city -->
      <div class="control-wrapper" *ngIf="!hasSent">
        <label class="form-title">Ort *</label>
        <input matInput class="form-control" placeholder="Ort" autocomplete="off" formControlName="city" name="city" />
        <mat-error *ngIf="form.controls['city']?.touched && form.controls['city']?.errors">
          Minst 3 tecken krävs
        </mat-error>
      </div>

      <!-- orgNo -->
      <div class="control-wrapper" *ngIf="!hasSent">
        <label class="form-title">Org. nummer</label>
        <input matInput class="form-control" placeholder="Org. nummer" autocomplete="off" formControlName="orgNo" name="orgNo" />
        <mat-error *ngIf="form.controls['orgNo']?.touched && form.controls['orgNo']?.errors">
          Ange organisationsnummer enligt följande format (xxxxxx-xxxx)
        </mat-error>
      </div>

      <!-- customerName -->
      <div class="control-wrapper" *ngIf="!hasSent">
        <label class="form-title">Ditt namn</label>
        <input
          matInput
          class="form-control"
          placeholder="Ditt namn"
          autocomplete="off"
          formControlName="customerName"
          name="customerName"
        />
      </div>

      <div *ngIf="!hasSent">
        <label class="form-title">Välj regioner du är intresserad av:</label>
        <div class="row row-cols-1 row-cols-md-3 g-1">
          <div class="col" *ngFor="let r of allRegions">
            <label>
              <input type="checkbox" (change)="onRegionToggle(r.id, $event.target.checked)" />
              {{ r.name }}
            </label>
          </div>
        </div>
      </div>

      <div class="registered-newsletter" *ngIf="hasSent">
        Grattis! Du kommer snart börja få nyheter, inspiration och erbjudanden direkt i din inkorg.
      </div>

      <div class="modal-footer">
        <button class="btn btn-light" mat-raised-button (click)="close()">Stäng</button>
        <button
          class="btn btn-primary"
          mat-raised-button
          (click)="onSubmit()"
          [disabled]="!form.valid || isSending"
          *ngIf="!hasSent"
        >
          Börja prenumerera
        </button>
      </div>
    </div>
  </form>
</div>
